'use client'

import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Cookie } from '@repo/tools'
import { Row } from '@repo/ui/components'
import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export interface AuthGuardProps {
  children: ReactNode
  className?: string
}

export const AuthGuard = ({ children, className }: AuthGuardProps) => {
  const { t } = useTranslate()

  // If user is not authenticated, show login/register buttons
  const authGuardClicked = () =>
    Cookie.setRedirectingUrl(window.location.pathname)

  if (!Cookie.get('access_token')) {
    return (
      <Row
        className={twMerge(
          'justify-center border border-border-neutral-surface-dark rounded-sm',
          className,
        )}
      >
        <ButtonLink
          href='/auth/register'
          onClick={authGuardClicked}
          variant='transparent'
          size='md'
          color='base'
        >
          {t('common_register')}
        </ButtonLink>
        <span>{t('common_or')}</span>
        <ButtonLink
          href='/auth/login'
          onClick={authGuardClicked}
          variant='transparent'
          size='md'
          color='base'
        >
          {t('common_login')}
        </ButtonLink>
      </Row>
    )
  }

  // If user is authenticated, show the children
  return children
}
